import { render, staticRenderFns } from "./ruku_add.vue?vue&type=template&id=3418a224&scoped=true"
import script from "./ruku_add.vue?vue&type=script&lang=js"
export * from "./ruku_add.vue?vue&type=script&lang=js"
import style0 from "./ruku_add.vue?vue&type=style&index=0&id=3418a224&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3418a224",
  null
  
)

export default component.exports